var exports = {
  "Tp": "x234b8571--987b0b--background",
  "KI": "x234b8571--987b0b--icon_container",
  "rV": "x234b8571--987b0b--click_area",
  "q9": "x234b8571--987b0b--click_area--left",
  "jW": "x234b8571--987b0b--click_area--disabled",
};

module.exports = exports;
